import { render, staticRenderFns } from "./InventoryEditRoomOverlay.vue?vue&type=template&id=868a22bc&"
import script from "./InventoryEditRoomOverlay.vue?vue&type=script&lang=ts&"
export * from "./InventoryEditRoomOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports